import { render } from "./page-komisaris.vue?vue&type=template&id=5319d5fc&scoped=true"
import script from "./page-komisaris.vue?vue&type=script&lang=js"
export * from "./page-komisaris.vue?vue&type=script&lang=js"

import "./page-komisaris.vue?vue&type=style&index=0&id=5319d5fc&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5319d5fc"]])

export default __exports__